// removed by extract-text-webpack-plugin
module.exports = {"dialog":"confirmation-module-dialog-eb8ab7d7c8a816b757ea5897bd9d9a30--","logoutDepth":"confirmation-module-logoutDepth-2232c75a2e76edaba5ff2a1bf73573ec--","container":"confirmation-module-container-8168cfb32ff53ed6eb4d3cb4594d87c6--","message":"confirmation-module-message-2658b38f5ee9411090115e140de57830--","buttons":"confirmation-module-buttons-dcffbdb6a807b6ab5adae0c0a97ad47c--","closeButton":"confirmation-module-closeButton-74dbf33e336a1791bfe39310b912efe2--","submitButton":"confirmation-module-submitButton-e69e97fa21e9efcf19ea6971e4a76e55--"};


//////////////////
// WEBPACK FOOTER
// /src/components/commonComponents/confirmationBox/confirmation.module.scss
// module id = 1648
// module chunks = 0